export function getCaretCoordinates(): {
  x: number
  y: number
} | null {
  const isSupported = typeof window.getSelection !== 'undefined'

  if (!isSupported) {
    return null
  }

  const selection = window.getSelection()

  if (!selection || selection.rangeCount === 0) {
    return null
  }

  const range = selection.getRangeAt(0)

  if (!range) {
    return null
  }

  const clone = range.cloneRange()
  clone.collapse(true)

  // Get the client rects for the collapsed range
  const rects = clone.getClientRects()

  // If a bounding rectangle is found, use its coordinates
  if (rects.length > 0) {
    const rect = rects[0]
    return {
      x: rect.left,
      y: rect.top,
    }
  }
  return null
}
